export const VIEWED_AD_TTL_MS = 24 * 60 * 60 * 1000;
